import { __decorate } from "tslib";
import { Component, Vue } from "../../../vue";
import { Modal } from 'ant-design-vue';
import { has } from "lodash-es";
import { ls } from "../../../core/common/ls";
import { METHOD_TYPES } from "../../../core/stateCommon/consts";
import { EDITOR_TAB, lsKey } from "../consts";
import { IMethodEditorState } from "../MethodEditorState";
import DocsPanel from "./DocsPanel";
import FormEditor from "./FormEditor";
import MethodCodeEditor from "./MethodCodeEditor";
import MethodDebugger from "./MethodDebugger";
import MethodInfo from "./MethodInfo";
import MethodSettings from "./MethodSettings";
import styles from "./style.module.css";
const elId = 'wuji_method_editor';
function getModalEl() {
  return document.getElementById(elId);
}
let MethodMainModal = class MethodMainModal extends Vue {
  constructor() {
    super(...arguments);
    this.width = 800;
  }
  get currentTab() {
    return this.state.currentTab;
  }
  set currentTab(val) {
    this.state.currentTab = val;
  }
  onClose() {
    this.state.onClose();
  }
  updateWidth() {
    if (!this.state.visible) {
      return;
    }
    const el = document.querySelector('.ucd-materialBox');
    if (el) {
      this.width = window.innerWidth - el.clientWidth;
    }
  }
  created() {
    this.updateWidth();
    this.$watch(() => this.state.visible, () => {
      this.updateWidth();
    });
    window.addEventListener('resize', this.updateWidth);
    const getConfig = () => {
      let config = ls.get(lsKey);
      if (!config) {
        config = {};
      }
      return config;
    };
    const config = getConfig();
    if (config.currentTab && Array.isArray(config.currentTab) && config.currentTab.length) {
      this.currentTab = config.currentTab;
    }
    this.$watch(() => this.currentTab, () => {
      const config = getConfig();
      config.currentTab = this.currentTab;
      ls.set(lsKey, config);
    });
    this.$watch(() => this.state.originMethodId, () => {
      const el = getModalEl();
      el === null || el === void 0 || el.focus();
    });
  }
  afterVisibleChange() {
    const {
      visible
    } = this.state;
    const el = getModalEl();
    if (!el) return;
    if (visible) {
      var _el$focus;
      el.addEventListener('keydown', this.onKeyDown);
      (_el$focus = el.focus) === null || _el$focus === void 0 || _el$focus.call(el);
    } else {
      el.removeEventListener('keydown', this.onKeyDown);
    }
  }
  beforeDestroy() {
    const el = getModalEl();
    el === null || el === void 0 || el.removeEventListener('keydown', this.onKeyDown);
  }
  onKeyDown(event) {
    const ctrl = event.ctrlKey || event.metaKey;
    if (ctrl && event.code === 'KeyS') {
      event.preventDefault();
      this.state.onSave();
    }
    if (event.code === 'F5') {
      event.preventDefault();
      this.state.debug();
    }
    if (event.code === 'Escape') {
      event.preventDefault();
      this.state.onClose();
    }
  }
  onReset() {
    const {
      method,
      canResetMethod
    } = this.state;
    if (!canResetMethod || !method) return;
    const hasChangeProp = has(method, 'unchanged');
    // 没有unchanged字段视为方法有改动
    const changed = hasChangeProp ? !method.unchanged : true;
    const reset = () => {
      this.state.resetMethod();
    };
    if (changed) {
      Modal.confirm({
        content: '重置该方法后会丢失以前的改动，是否确定重置',
        okText: '重置',
        cancelText: '取消',
        onOk: reset,
        onCancel: () => {}
      });
    } else {
      reset();
    }
  }
  render() {
    var _this$state$method, _this$state$method2;
    const h = arguments[0];
    return h("a-drawer", {
      "class": styles.methodEditor,
      "attrs": {
        "keyboard": false,
        "placement": "right",
        "mask": false,
        "visible": this.state.visible,
        "width": this.width,
        "wj-mod": "数据源方法",
        "id": "wuji_method_editor",
        "afterVisibleChange": this.afterVisibleChange
      },
      "on": {
        "close": this.onClose
      }
    }, [h("div", {
      "class": styles.header,
      "slot": "title"
    }, [h("span", {
      "class": "ant-drawer-title"
    }, [this.state.title]), h("div", {
      "class": styles.btns
    }, [h("a-space", [this.state.modified ? h("a-tag", {
      "attrs": {
        "color": "orange"
      }
    }, ["\u6709\u53D8\u66F4"]) : null, this.state.hasError ? h("a-tag", {
      "attrs": {
        "color": "red"
      }
    }, ["\u6709\u8BED\u6CD5\u9519\u8BEF"]) : null, this.state.canResetMethod ? h("a-button", {
      "key": "reset",
      "on": {
        "click": this.onReset
      },
      "attrs": {
        "wj-eid": "重置方法"
      }
    }, ["\u91CD\u7F6E\u65B9\u6CD5"]) : null, (_this$state$method = this.state.method) !== null && _this$state$method !== void 0 && _this$state$method.system ? h("a-button", {
      "key": "save_exce",
      "attrs": {
        "type": "primary",
        "wj-eid": "保存并执行后退出",
        "guide-el": `wuji-method-save-${this.state.method.id}`
      },
      "on": {
        "click": () => this.state.onSaveAndExit(true)
      }
    }, ["\u4FDD\u5B58\u5E76\u6267\u884C\u540E\u9000\u51FA"]) : h("a-button", {
      "key": "save_exit",
      "attrs": {
        "type": "primary",
        "wj-eid": "保存并退出",
        "guide-el": `wuji-method-save-${((_this$state$method2 = this.state.method) === null || _this$state$method2 === void 0 ? void 0 : _this$state$method2.id) || 'unknown'}`
      },
      "on": {
        "click": () => this.state.onSaveAndExit(false)
      }
    }, ["\u4FDD\u5B58\u5E76\u9000\u51FA"])])])]), this.renderContent()]);
  }
  renderContent() {
    const h = this.$createElement;
    return h("div", {
      "class": styles.content
    }, [this.renderLeft(), this.renderRight()]);
  }
  toggleMethodType() {
    if (!this.state.method) {
      return;
    }
    if (this.state.method.type === METHOD_TYPES.code) {
      this.state.transformToForm();
    } else {
      this.state.transformToCode();
    }
  }
  renderChangeMethodType() {
    const h = this.$createElement;
    const {
      isCode,
      method,
      convertible
    } = this.state;
    const title = (method === null || method === void 0 ? void 0 : method.type) === METHOD_TYPES.code ? '切换到可视化模式' : '切换到代码模式';
    const changeMethodType = method && convertible ? h("a-tooltip", {
      "attrs": {
        "title": "注意：可视化模式和代码模式互不联动，逻辑隔离"
      }
    }, [h("a-button", {
      "attrs": {
        "type": "link",
        "size": "small"
      },
      "on": {
        "click": this.toggleMethodType
      },
      "style": isCode ? '' : 'float:right;right:0;'
    }, [title, h("a-icon", {
      "attrs": {
        "type": "right"
      }
    })])]) : null;
    return changeMethodType;
  }
  renderLeft() {
    const h = this.$createElement;
    const {
      isCode,
      isForm
    } = this.state;
    return h("aside", {
      "class": styles.left
    }, [h("div", {
      "class": styles.contentBlock
    }, [h(MethodInfo)]), h("div", {
      "class": [styles.contentBlock]
    }, [h("div", {
      "class": styles.methodHeader
    }, [this.renderChangeMethodType()]), h(MethodCodeEditor, {
      "directives": [{
        name: "show",
        value: isCode
      }]
    }), h(FormEditor, {
      "directives": [{
        name: "show",
        value: isForm
      }]
    })]), h("div", {
      "class": styles.contentBlock
    }, [h(MethodSettings)])]);
  }
  renderRight() {
    const h = this.$createElement;
    return h("aside", {
      "class": styles.right
    }, [h("a-menu", {
      "attrs": {
        "mode": "horizontal"
      },
      "style": "margin-bottom: 1px;border: 1px solid #e8e8e8;border-bottom:none;border-radius: 4px 4px 0 0;",
      "model": {
        value: this.currentTab,
        callback: $$v => {
          this.currentTab = $$v;
        }
      }
    }, [h("a-menu-item", {
      "key": EDITOR_TAB.doc,
      "attrs": {
        "wj-eid": "文档tab"
      }
    }, [h("a-icon", {
      "attrs": {
        "type": "read"
      }
    }), "\u6587\u6863"]), h("a-menu-item", {
      "key": EDITOR_TAB.debug,
      "attrs": {
        "wj-eid": "调试tab"
      }
    }, [h("a-icon", {
      "attrs": {
        "type": "caret-right"
      }
    }), "\u8C03\u8BD5"])]), h("a-card", {
      "style": "height:calc(100% - 48px);border-radius: 0 0 4px 4px;border-top:none;",
      "attrs": {
        "bodyStyle": {
          height: '100%',
          overflow: 'hidden',
          padding: '16px'
        },
        "title": null
      }
    }, [h(DocsPanel, {
      "directives": [{
        name: "show",
        value: this.currentTab.includes(EDITOR_TAB.doc)
      }]
    }), h(MethodDebugger, {
      "directives": [{
        name: "show",
        value: this.currentTab.includes(EDITOR_TAB.debug)
      }]
    })])]);
  }
};
__decorate([IMethodEditorState], MethodMainModal.prototype, "state", void 0);
MethodMainModal = __decorate([Component({
  name: 'MethodMainModal'
})], MethodMainModal);
export { MethodMainModal };
//# sourceMappingURL=MethodMainModal.js.map
